<template>
  <footer class="container footer">
    <img src="../../../../static/powered_by_blumar.png" alt="Powered by Blumar" class="footer-image" />
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>
.footer {
  width: 100%;
  padding: 10px;
  padding-right: 50px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: transparent;
}

.footer-image {
  height: 40px;
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/footer/Footer.vue